import { NgModule } from '@angular/core';
import { LoginSignupService } from './login-signup.service';

@NgModule({
  imports: [],
  providers: [LoginSignupService],
})
export class LoginSignupModule {}
